/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';
import EdifyGmailAuthScopeProvider from 'PlugAndPlay/_global/jsx/integrations/google/EdifyGmailAuthScopeProvider.jsx';
import LocalStorageGmailAuthScopeProvider from 'PlugAndPlay/_global/jsx/integrations/google/LocalStorageGoogleAuthScopeProvider.jsx';
import GmailProvider, {
    LOCAL_SCOPE_STORAGE_ID,
} from './data/emails-listing-gmail-provider';
import OutlookProvider from './data/emails-listing-outlook-provider';

import { LoadingState } from './emails-listing';

// Lazy load the main 'app'
const EmailsListing = React.lazy(() =>
    import(/* webpackChunkName: "EmailsListing" */ './emails-listing')
);

// Export for unit tests only.
function init(
    GmailProviderFn = GmailProvider,
    EdifyGmailAuthScopeProviderFn = EdifyGmailAuthScopeProvider,
    LocalStorageGmailAuthScopeProviderFn = LocalStorageGmailAuthScopeProvider,
    OutlookProviderFn = OutlookProvider
) {
    const appWrapper = document.querySelectorAll(
        '[data-component="emails-listing"]'
    );

    // Don't run on a non app page
    if (appWrapper.length > 0) {
        // Only load ReactDOM from if its needed as its pretty large
        import(/* webpackChunkName: "ReactDOM" */ 'react-dom').then(
            (ReactDOM) => {
                appWrapper.forEach((wrapper) => {
                    let emailsListingWrapper;
                    const { dataset } = wrapper;
                    const appConfiguration = JSON.parse(
                        dataset.appConfiguration
                    );

                    const emailsListing = (
                        <EmailsListing {...appConfiguration} />
                    );

                    if (!appConfiguration.datasource) {
                        emailsListingWrapper = <div>Missing datasource!</div>;
                    }

                    if (appConfiguration.datasource === 'outlook') {
                        emailsListingWrapper = (
                            <OutlookProviderFn
                                clientId={appConfiguration.clientId}
                            >
                                {emailsListing}
                            </OutlookProviderFn>
                        );
                    }

                    if (appConfiguration.datasource === 'gmail') {
                        emailsListingWrapper = (
                            <GmailProviderFn
                                clientId={appConfiguration.clientId}
                            >
                                {emailsListing}
                            </GmailProviderFn>
                        );

                        if (appConfiguration.scopeApprovalSource === 'edify') {
                            // Edify stores it against the student record
                            const datastore = new Datastore({
                                serviceURL: appConfiguration.datastore.url,
                                jwtURL: appConfiguration.datastore.jwt,
                            });

                            emailsListingWrapper = (
                                <EdifyGmailAuthScopeProviderFn
                                    datastore={datastore}
                                >
                                    {emailsListingWrapper}
                                </EdifyGmailAuthScopeProviderFn>
                            );
                        } else {
                            // Otherwise assume its in the local storage
                            emailsListingWrapper = (
                                <LocalStorageGmailAuthScopeProviderFn
                                    localStorageKey={
                                        appConfiguration.localStorageKey ||
                                        LOCAL_SCOPE_STORAGE_ID
                                    }
                                >
                                    {emailsListingWrapper}
                                </LocalStorageGmailAuthScopeProviderFn>
                            );
                        }
                    }

                    ReactDOM.render(
                        <Suspense fallback={<LoadingState />}>
                            {emailsListingWrapper}
                        </Suspense>,
                        wrapper
                    );
                });
            }
        );
    }
}

init();

export default init;
